import { Component, OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { LottieImage } from '../../../shared/models/abre-cuentas.model';
import { ExternalResponse } from '../../../shared/models/channel-communicator/external-response.model';
import { DocumentModel } from '../../../shared/models/document.model';
import { OccupationModel } from '../../../shared/models/occupation.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import {
  ChannelCommunicatorService,
} from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { FingerPrintScanImage } from './finger-print-scan-image';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

@Component({
  selector: 'app-finger-prints-scan',
  templateUrl: './finger-prints-scan.component.html',
  styleUrls: ['./finger-prints-scan.component.scss'],
})
export class FingerPrintsScanComponent implements OnInit {

  private incomesRequest: boolean;
  private clientDataRequest: boolean;
  private clientDataRequestNext: string;
  private incomesRequestNext: string;
  selectedOccupation: OccupationModel;
  dataClient: any;
  isBtnDisabled = true;
  customErrorMessage: string;
  infoDocument = new DocumentModel();
  maxScanAttempts: number;
  scanResponse: ExternalResponse;
  image: LottieImage;
  callIncomesError: boolean;

  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private navigationService: NavigationService,
    private validationHelperService: ValidationHelperService,
    private headerService: HeaderService,
    private identificationService: IdentificationService,
    private taggingService: TaggingService,
    private loaderService: LoaderService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(true, true, true);
    this.maxScanAttempts = this.abreCuentasService.getBytteConfig().failedAttempts.fingerPrintsScan;
    this.callIncomesError = false;
    this.incomesRequest = false;
    this.clientDataRequest = false;
  }

  ngOnInit() {
    this.image = {
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: FingerPrintScanImage,
    };
    this.infoDocument = this.abreCuentasService.getDocumentInfo();
  }

  async next() {
    // this.loaderService.show();
    try {
      await this.callScanNewVersions();
    } catch (err) {
      // this.loaderService.hide();
      console.log(err);
    }
  }

  async resumeApp() {
    // this.loaderService.show();
    if (!this.scanResponse.code) {
      // this.loaderService.hide();
      this.navigationService.navigateToGeneralInformation('500');
      return;
    }

    switch (this.scanResponse.code) {
      case '400': // Wrong license activation key
      case '403': // Origin not authorized
      case '404': // Operation not found
      case '500': // Internal error
        // this.loaderService.hide();
        this.navigationService.navigateToGeneralInformation('500');
        return;
      case '504': // Failed attempt
        // this.loaderService.hide();
        this.abreCuentasService.getAbreCuentasModel().fingerPrintsScanAttempts++;
        if (this.abreCuentasService.getAbreCuentasModel().fingerPrintsScanAttempts >= this.maxScanAttempts) {
          this.navigationService.pageLoadTag('ErrorHuellasInvalidas', ['pv20', 'pv115', 'pv75', '']);
          this.abreCuentasService.caseInfoError('102');
          this.navigationService.nextStep('102');
        } else {
          this.navigationService.pageLoadTag('ErrorCapturaHuellas', ['pv222', 'pv114', 'pv74', '']);
          this.abreCuentasService.setImageLottieError(this.image);
          this.abreCuentasService.caseInfoError('113');
          this.navigationService.nextStep('113');
        }
        // this.loaderService.hide();
        return;
    }
    this.navigationService.pageLoadTag(false, ['pv19', 'pv108', 'pv67']);
    const tagPageName = this.taggingService.getTagIdByProduct();
    this.pageTagEvent(tagPageName);
    await this.sendFingerPrints();
  }

  async sendFingerPrints() {
    await this.identificationService
      .sendFingerPrintsInfo(this.scanResponse)
      .then(async res => {
        this.channelCommunicatorService.getImpl().cleanResidualFiles();
        let nextCode: string;
        if (res.status === 500) {
          // this.loaderService.hide();
          this.navigationService.nextStep('200');
          return;
        }
        if (res.status !== 200) {
          const codigo = res.body.codigo;
          switch (codigo) {
            case '422-01':
            case '422-02':
            default:
              nextCode = '103';
              break;
          }
          // this.loaderService.hide();
          this.navigationService.nextStep(nextCode);
        } else if (res.body.verification_status === 'false') {
          nextCode = '102';
          // this.loaderService.hide();
          this.abreCuentasService.caseInfoError('102');
          this.navigationService.nextStep(nextCode);
          return;
        }
        nextCode = '200';
        // this.loaderService.hide();
        const bitacoraEvent = 'biometric-validation-proces-succes';
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.navigationService.nextStep(nextCode);
      }).catch(() => {
        this.navigationService.navigateToGeneralInformation('500');
        // this.loaderService.hide();
      });
  }

  pageTagEvent(tagPageName: string) {
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.image,
          position: EVENT.customCategory.position.center,
        },
        action: EVENT.customAction.show,
        label: EVENT[`${tagPageName}E1customLabel`],
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  private async callScanNewVersions() {
    await this.channelCommunicatorService
      .getImpl()
      .verifyAndRequestPermissions()
      .then(async p => {
        if (!p.code || p.code !== '200') {
          // this.loaderService.hide();
          this.navigationService.navigateToGeneralInformation('401');
        }

        const finger = this.abreCuentasService.getDocumentInfo().finger_printed.toString();
        const seconds = this.abreCuentasService.getBytteConfig().timeouts.fingerPrintsScan.seconds;
        await this.channelCommunicatorService.getImpl().fingerPrintsScan(finger, this.abreCuentasService.getTransactionId(), seconds).then(e1 => {
          // this.loaderService.hide();
          this.scanResponse = e1;
          this.resumeApp();
        }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
      }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }
}
